<app-page>
  <ng-template #headerTpl>
    <app-header></app-header>
  </ng-template>

  <ng-template #mainTpl>
    <div class="partners-page">
      <!-- Animated Background -->
      <div class="animated-bg">
        <div class="floating-shapes">
          <div class="shape shape-1"></div>
          <div class="shape shape-2"></div>
          <div class="shape shape-3"></div>
          <div class="shape shape-4"></div>
          <div class="shape shape-5"></div>
        </div>
      </div>

      <!-- Hero Section -->
      <section class="hero-section">
        <div class="container">
          <div class="hero-content">
            <h1 class="hero-title">
              <span class="title-line">Our</span>
              <span class="title-line">Partners</span>
            </h1>
            <p class="hero-description">
              <ng-container i18n>At HostelHop, we believe in building meaningful partnerships that make travel easier, cheaper, and more rewarding for our community.</ng-container>
            </p>
          </div>
        </div>
      </section>

      <!-- Partners Grid -->
      <section class="partners-grid-section">
        <div class="container">
          <!-- FlixBus Card -->
          <div class="partner-card flixbus-card">
            <div class="card-content">
              <div class="image-side">
                <div class="logo-container">
                  <img src="assets/icons/flixbus_logo.svg" alt="FlixBus Logo" class="partner-logo-image" />
                </div>
              </div>
              
              <div class="content-side">
                <h3 class="partner-name text-3xl font-bold mb-2">
                  <ng-container i18n>FlixBus</ng-container>
                </h3>
                <div class="partner-type-label text-sm font-medium uppercase mb-4" i18n>TRANSPORTATION PARTNER</div>
                
                <div class="partner-tags mb-4">
                  <span class="partner-tag" i18n>Sustainable Travel</span>
                  <span class="partner-tag" i18n>Global Network</span>
                  <span class="partner-tag" i18n>Tech Innovation</span>
                </div>
                
                <div class="partner-description">
                  <p>
                    <ng-container i18n>Flix is a leading global travel-tech company, aiming to provide sustainable and affordable travel solutions, with a track record of offering such solutions to more than 500 million travelers since its launch, across more than 40 countries on 4 continents through its brands FlixBus, FlixTrain, Greyhound, and Kâmil Koç.</ng-container>
                  </p>
                  <p>
                    <ng-container i18n>Leveraging an asset-light business model and an innovative technology platform for both travelers and partners, Flix swiftly achieved market-leading positions for long-distance bus travel across Europe, North America, and Türkiye, and is rapidly expanding further into South America and Asia.</ng-container>
                  </p>
                </div>
                
                <div class="card-footer">
                  <a href="https://www.flix.com/" class="btn btn-primary flex-center" target="_blank" rel="noopener noreferrer">
                    <span i18n>Go to Partners Website</span>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <!-- Aloha Card -->
          <div class="partner-card aloha-card">
            <div class="card-content">
              <div class="image-side">
                <div class="logo-container">
                  <img src="assets/icons/aloha-logo.svg" alt="Aloha Logo" class="partner-logo-image" />
                </div>
              </div>
              
              <div class="content-side">
                <h3 class="partner-name text-3xl font-bold mb-2">
                  <ng-container i18n>Aloha</ng-container>
                </h3>
                <div class="partner-type-label text-sm font-medium uppercase mb-4" i18n>TECHNOLOGY PARTNER</div>
                
                <div class="partner-tags mb-4">
                  <span class="partner-tag" i18n>PMS System</span>
                  <span class="partner-tag" i18n>Channel Manager</span>
                  <span class="partner-tag" i18n>Booking Engine</span>
                </div>
                
                <div class="partner-description">
                  <p>
                    <ng-container i18n>Aloha is an all-in-one hotel management software for properties in Latin America, Brazil, and the United States. It's designed for independent hotels, hostels, beach houses, cabins, and short-term rentals.</ng-container>
                  </p>
                  <p>
                    <ng-container i18n>Its main product, Aloha Pro, helps centralize bookings, automate operations, and improve daily workflows with PMS, Channel Manager, and commission-free booking engine capabilities.</ng-container>
                  </p>
                </div>
                
                <div class="card-footer">
                  <a href="https://aloha.co/" class="btn btn-primary flex-center" target="_blank" rel="noopener noreferrer">
                    <span i18n>Go to Partners Website</span>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <!-- Coming Soon Card -->
          <div class="partner-card coming-soon-card">
            <div class="card-content coming-soon-content">
              <div class="coming-soon-icon">
                <div class="clock-icon">
                  <div class="clock-face-simple">
                    <div class="clock-face-inner">
                      <div class="clock-center-simple"></div>
                      <div class="clock-hour-hand-simple"></div>
                      <div class="clock-minute-hand-simple"></div>
                    </div>
                  </div>
                </div>
              </div>
              
              <h3 class="coming-soon-title">
                <ng-container i18n>Coming Soon!</ng-container>
              </h3>
              
              <p class="coming-soon-description">
                <ng-container i18n>More exciting partnerships are on the way. Stay tuned for new collaborations that bring even more value to our travelers and hostel partners.</ng-container>
              </p>
              
              <div class="coming-soon-feature-tiles">
            <div class="feature-tile">
              <div class="feature-icon global-icon">
                <img src="assets/icons/globe-svg.svg" alt="Global Travel Services" width="32" height="32" />
              </div>
              <div class="feature-text">
                <div>Global Travel</div>
                <div>Services</div>
              </div>
            </div>
            
            <div class="feature-tile">
              <div class="feature-icon payment-icon">
                <img src="assets/icons/credit-card-svg.svg" alt="Payment Solutions" width="32" height="32" />
              </div>
              <div class="feature-text">
                <div>Payment</div>
                <div>Solutions</div>
              </div>
            </div>
            
            <div class="feature-tile">
              <div class="feature-icon experience-icon">
                <img src="assets/icons/target-svg.svg" alt="Experience Platforms" width="32" height="32" />
              </div>
              <div class="feature-text">
                <div>Experience</div>
                <div>Platforms</div>
              </div>
            </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <!-- Partnership CTA Section -->
    <section class="partnership-cta-section">
      <div class="cta-content text-center">
        <h2 class="cta-title text-4xl font-bold mb-3" i18n>Interested in partnering with us?</h2>
        <p class="cta-description text-lg mb-4" i18n>
          Join our growing network of partners and help us create better travel experiences for backpackers worldwide.
        </p>
      <a href="/help#talk-to-us" class="cta-button flex-center">
        <span i18n>Get in touch</span>
        <span class="arrow">→</span>
      </a>
      </div>
    </section>
  </ng-template>
</app-page>
